import { type ILoginData } from "@/store/reducers/LoginSlice";
import { useAppSelector } from "@/store/storeHooks";

export type IRoles_ = ILoginData["role"];

export const useRoleManager = () => {
  const loginData = useAppSelector((store) => store.LoginState.loginData);
  const { is_boss, role } = loginData || {};

  // I used "_id" prop for public roles and to home page
  const hasAccess = (roleName: keyof IRoles_ = "_id") => {
    if (is_boss) {
      return true;
    }
    if (roleName === "_id") {
      return true;
    }
    try {
      const checkAccess = role?.[roleName];
      return !!checkAccess;
    } catch (error) {
      console.error('Error in hasAccess:', error);
      return false;
    }
  };
  return hasAccess;
};
